import { useState, } from "react";
import Icons from "../myIcon/Icons";
import { Link } from "react-router-dom";
import React from "react";

export default function MobileMenu({ isOpen, setIsOpen}) {
  const [isInner3, setIsInner3] = useState(false);
  
  const handleLinkClick = () => {
    setIsOpen(false); 
  };

  return (
    <>
    <section className={isOpen ? "mobilemenu-area open-menu" : "mobilemenu-area close-menu"}>
      <div className="mobilemenu-header">
        <Link to={"/"} onClick={handleLinkClick}><img src="/image/logo.webp" alt="Logo" /></Link>
        <button className="menu-close-btn" onClick={() => {handleLinkClick(); setIsInner3(false);}} aria-label="Close menu">✕</button>
      </div>

      <ul className="mobile-mainmenu">
        <li><Link to={"/"} onClick={handleLinkClick}>Home</Link></li>
        <li><Link to={"/about"} onClick={handleLinkClick}>About</Link></li>
        <li><Link onClick={()=>setIsInner3(true)}>Collection <Icons name="arrowRight"/></Link></li>
        <li><Link to={"/our-process"} onClick={handleLinkClick}>Our Process</Link></li>
        <li><Link to={"/gifting"} onClick={handleLinkClick}>Gifting</Link></li>
        <li><Link to={"/wedding-dress-designers"} onClick={handleLinkClick}>Wedding Closet</Link></li>
        <li><Link to={"/collaboration"} onClick={handleLinkClick}>Collaboration</Link></li>
        <li><Link to={"/contact"} onClick={handleLinkClick}>Appointment</Link></li>
      </ul>

      <div className={isInner3 ? "mobilemenu-inner open-inner" : "mobilemenu-inner"}>
        <div className="mobileinner-data">
            <Link onClick={()=>setIsInner3(false)} className="menu-back"><Icons name="arrowLeft"/> Back</Link>

            <div className="mobileinner-link">
                <Link to={"/haldi-dresses"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Haldi</Link>
                <Link to={"/mehandi-dresses"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Mehandi</Link>
                <Link to={"/sangeet-suit"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Sangeet</Link>
                <Link to={"/contemporary"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Contemporary</Link>
                <Link to={"/wedding-dress-designers"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Wedding</Link>  
                <Link to={"/festive"} onClick={() => {handleLinkClick(); setIsInner3(false);}}>Festive</Link>    
            </div>
        </div>
      </div>
    </section>
    </>
  )
}
